// BrandMark — the square "app icon" treatment for the FamChest logo.
//
// Renders the real brand asset (public/assets/famchest/icon.png, a
// square crop of the heart mark) inside the rounded tile instead of a
// generic lucide glyph, so every surface that uses this component shows
// the actual FamChest icon. The tile provides the shape, the mark
// provides the brand.
//
// Where the layout has room for a full wordmark (auth pages, headers)
// prefer <BrandLogo /> — this component is for compact icon slots:
// nav rail, top bar, loading spinner, small footers.

import { brandAssets } from "@/lib/brandAssets";
import { cn } from "@/lib/utils";

type BrandMarkProps = {
  size?: "sm" | "md" | "lg";
  tone?: "color" | "light";
  className?: string;
};

const sizes: Record<NonNullable<BrandMarkProps["size"]>, string> = {
  sm: "h-8 w-8",
  md: "h-10 w-10",
  lg: "h-12 w-12",
};

export function BrandMark({
  size = "md",
  tone = "color",
  className,
}: BrandMarkProps) {
  return (
    <span
      aria-hidden
      className={cn(
        "inline-flex items-center justify-center overflow-hidden rounded-xl shadow-sm",
        tone === "color"
          ? "bg-gradient-to-br from-primary to-primary/70"
          : "bg-white/15 ring-1 ring-white/30 backdrop-blur",
        sizes[size],
        className,
      )}
    >
      <img
        src={brandAssets.icon}
        alt=""
        className="h-full w-full object-contain p-[10%]"
        loading="eager"
        decoding="async"
      />
    </span>
  );
}
